export default import.meta.ROLLDOWN_FILE_URL_6NpOe9n0jeRY_FVLYNKmYg